import { AmplitudeClient } from 'amplitude-js'
import amplitude from 'amplitude-js'

const isBrowser = typeof window !== 'undefined'

export class AmplitudeUtils {
  private static getInstance(): AmplitudeClient {
    return amplitude.getInstance()
  }

  static init() {
    if (isBrowser && process.env.REACT_APP_AMPLITUDE_API_KEY) {
      AmplitudeUtils.getInstance().init(process.env.REACT_APP_AMPLITUDE_API_KEY)
    }
  }

  static logEvent(event: string, data?: any) {
    if (isBrowser && process.env.REACT_APP_AMPLITUDE_API_KEY) {
      AmplitudeUtils.getInstance().logEvent(event, data)
    }

    if (process.env.NEXT_PUBLIC_AMPLITUDE_LOGGING === 'true') {
      console.log(event, data)
    }
  }
}

export enum AmplitudeEvent {
  // Supply
  SupplyClick = 'SUPPLY_CLICK',
  SupplyConfirm = 'SUPPLY_CONFIRM',
  SupplyCancel = 'SUPPLY_CANCEL',
  SupplyInputChange = 'SUPPLY_INPUT_CHANGE',
  // Withdraw
  WithdrawClick = 'WITHDRAW_CLICK',
  WithdrawConfirm = 'WITHDRAW_CONFIRM',
  WithdrawCancel = 'WITHDRAW_CANCEL',
  WithdrawInputChange = 'WITHDRAW_INPUT_CHANGE',
  // Boost collateral
  BoostCollateralClick = 'BOOST_COLLATERAL_CLICK',
  BoostCollateralConfirm = 'BOOST_COLLATERAL_CONFIRM',
  BoostCollateralCancel = 'BOOST_COLLATERAL_CANCEL',
  // Borrow
  BorrowClick = 'BORROW_CLICK',
  BorrowConfirm = 'BORROW_CONFIRM',
  BorrowCancel = 'BORROW_CANCEL',
  BorrowInputChange = 'BORROW_INPUT_CHANGE',
  // Borrow
  RepayClick = 'REPAY_CLICK',
  RepayConfirm = 'REPAY_CONFIRM',
  RepayCancel = 'REPAY_CANCEL',
  RepayInputChange = 'REPAY_INPUT_CHANGE',
  // Broadcast
  BroadcastTx = 'BROADCAST_TX',
  BroadcastError = 'BROADCAST_ERROR',
}
